module.exports = __webpack_public_path__ + "img/shortcode_hifi_2.4aaaf353.png";